import { useRef, useState, FormEvent } from "react"

interface ChatFormProps {
  chatHistory: any,
  setChatHistory: React.Dispatch<React.SetStateAction<{ role: string; text: string; }[]>>,
}

export const TypingIndicator = () => {
  return (
    <div className="typing-indicator">
      <span className="dot" />
      <span className="dot" />
      <span className="dot" />
    </div>
  )
}

export const ChatForm = ({ chatHistory, setChatHistory }: ChatFormProps) => {
  const inputRef = useRef<HTMLInputElement>(null)
  const [isWaitingForResponse, setIsWaitingForResponse] = useState(false)

  const handleFormSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const userMessage = inputRef.current?.value.trim()
    if (!userMessage) return

    if (inputRef.current) {
      inputRef.current.value = ""
    }

    const updatedHistory = [...chatHistory, { role: "user", text: userMessage }]
    setChatHistory(updatedHistory)

    const thinkingMessage = { role: "model", text: "Thinking...", type: "typing" }
    setChatHistory([...updatedHistory, thinkingMessage])
    setIsWaitingForResponse(true)
  }

  return (
    <form className="chat-form" onSubmit={handleFormSubmit}>
      <input
        ref={inputRef}
        type="text"
        placeholder="Message..."
        className="message-input"
        required
      />
      <button
        type="submit"
        className="material-symbols-rounded"
        disabled={isWaitingForResponse}
      >
        {isWaitingForResponse ? (
          <span className="loading-spinner" />
        ) : (
          "arrow_upward"
        )}
      </button>
    </form>
  )
}
